import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { VendingRecycleSpotFillRateLineChart, hasChartData } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast30DaysChartRange } from '../../../statistics/pudo/last-30-days-chart-range';
import { useInsightFetchRange } from '../insight-detail/use-insight-fetch-range';

export const useLast30DaysVendingRecycleSpotFillRateLineChart = (accountId: string) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast30DaysChartRange);

    useEffect(() => {
        if (!accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;

        ChartClient.fetchChartData(accountId, VendingRecycleSpotFillRateLineChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [accountId, fetchRange.key]);

    return {
        data,
        isLoading,
        hasData: hasChartData(data)
    };
};
